import { useCallback } from "react";
import useWindowSize from "./useWindowSize";

export const breakpointSizes = {
  xxs: 385,  // Extra small devices (e.g., mobile phones)
  xsm: 410,  // Extra small devices (e.g., mobile phones)
  xs: 435,  // Extra small devices (e.g., mobile phones)
  sm: 540,  // Small devices (e.g., tablets)
  md: 720, // Medium devices (e.g., desktops)
  lg: 992, // Large devices (e.g., larger desktops)
  xl: 1440  // Extra large devices (e.g., large screens)
};

type Breakpoints = "xl" | "lg" | "md" | "sm" | "xs" | "xsm" | "xxs";
export const useBreakpoints = (breakpoint: Breakpoints): "lower" | "upper" => {
  let { width } = useWindowSize();
  let getSizeState = useCallback(
    (point: number) => {
      if (width >= point) {
        return "upper";
      } else {
        return "lower";
      }
    },
    [width],
  );
  switch (breakpoint) {
    case "xl": {
      return getSizeState(breakpointSizes.xl);
    }
    case "lg": {
      return getSizeState(breakpointSizes.lg);
    }
    case "md": {
      return getSizeState(breakpointSizes.md);
    }
    case "sm": {
      return getSizeState(breakpointSizes.sm);
    }
    case "xs": {
      return getSizeState(breakpointSizes.xs);
    }
    case "xsm": {
      return getSizeState(breakpointSizes.xsm);
    }
    case "xxs": {
      return getSizeState(breakpointSizes.xxs);
    }
  }
};
